module.exports = __webpack_public_path__ + "img/safe-border.051a2097.png";